import { render, staticRenderFns } from "./BaseDocumentMgrandDropoff.vue?vue&type=template&id=c0aaddb0"
import script from "./BaseDocumentMgrandDropoff.vue?vue&type=script&lang=js"
export * from "./BaseDocumentMgrandDropoff.vue?vue&type=script&lang=js"
import style0 from "./BaseDocumentMgrandDropoff.vue?vue&type=style&index=0&id=c0aaddb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports